// Word-by-word outline-to-fill headings with optional primary/secondary highlights.
// Hero animates on load; section headings animate when ScrollReveal adds .is-visible.

const PUNCT_ONLY = /^[.,!?;:…'"’”)\]]+$/;

export function buildAnimatedHeading(segments) {
  // Flatten segments into word/space tokens, keeping each word's highlight class
  const tokens = [];
  for (const segment of segments) {
    const highlightClass = segment.highlight ? ` title-word--${segment.highlight}` : "";
    for (const part of segment.text.split(/(\s+)/)) {
      if (!part) continue;
      if (/^\s+$/.test(part)) tokens.push({ space: part });
      else tokens.push({ word: part, highlightClass });
    }
  }

  let wordIndex = 0;
  const html = [];
  for (const token of tokens) {
    if (token.space) {
      html.push(token.space);
      continue;
    }

    const span = `<span class="title-word${token.highlightClass}" style="--word-i: ${wordIndex}">${token.word}</span>`;
    wordIndex += 1;

    // Punctuation that directly follows a word (".", ", ") must never wrap
    // onto its own line — bind it to the previous word with a nowrap wrapper.
    const prev = html[html.length - 1];
    if (PUNCT_ONLY.test(token.word) && prev && !/\s$/.test(prev)) {
      html[html.length - 1] = `<span style="white-space: nowrap">${prev}${span}</span>`;
    } else {
      html.push(span);
    }
  }

  return html.join("");
}

export const buildAnimatedTitle = buildAnimatedHeading;
